import defaultstates from './defaultState'
let state = Object.assign({}, defaultstates)
let BLACK_LIST = ['httpStatus','httpData'];
//需要存localStorage，mutations中updateState方法也用到此名单
let LOCAL_LIST = ['liveVideoUrlData'];
let handler = {
    set: function (obj, prop, value) {
        if (!BLACK_LIST.includes(prop) && !LOCAL_LIST.includes(prop)) {
            window.sessionStorage.setItem(prop, JSON.stringify(value));
        }else if(LOCAL_LIST.includes(prop)){
            window.localStorage.setItem(prop, JSON.stringify(value));
        }else {

        }
        return Reflect.set(obj, prop, value)
    }
}
export default new Proxy(state, handler);


// WEBPACK FOOTER //
// ./src/store/states.js